import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('admin-support-tickets-list', {
  template: require('./template.html'),
  name: 'admin-support-tickets-list',
  components: {
    dropsLoader,
  },
  computed: {
    ...mapGetters(['currentUser', 'cache']),
    userTickets() {
      return this.currentUser.tickets || [];
    },
    tickets() {
      const tickets = this.userTickets;
      const sortOn = this.sortKey || this.cols[3];
      return _.chain(tickets)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                // only gather the cols the table needs from data
                const e = [];
                _.forEach(this.cols, (c) => {
                  const col = this.cleanItem(row[c], c, row);
                  e.push(col);
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .sort((a, b) => {
          // We'll sort accending by default and we'll also ignore case
          // since that may confuse non-technical users
          const ascDesc = this.sortMap[sortOn];
          a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn]; // eslint-disable-line
          b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn]; // eslint-disable-line
          return (a === b ? 0 : a < b ? -1 : 1) * ascDesc; // eslint-disable-line
        })
        .value();
    },
  },
  data() {
    const cols = ['subject', 'status', 'priority', 'updated', 'created'];
    const sortMap = _.zipObject(cols, _.fill(Array(cols.length), -1));
    return {
      loading: false,
      refreshing: false,
      cols,
      sortMap,
      sortKey: '',
      filterKey: '',
      paginate: ['ticketlist'],
    };
  },
  created() {
    this.loadTickets();
  },
  methods: {
    async loadTickets(refresh) {
      if (!this.cache.tickets) {
        try {
          this.loading = true;
          if (refresh) {
            this.refreshing = true;
          }
          const { tickets } = await this.$lightning([{
            name: 'getSupportTickets',
          }]);
          this.$store.dispatch('setGlobalValue', {
            item: this.currentUser,
            key: 'tickets',
            value: _.cloneDeep(tickets),
          });
          this.$store.dispatch('setGlobalValue', {
            item: this.cache,
            key: 'tickets',
            value: true,
          });
        } catch (e) {
          const message = e.message || e;
          this.$log.error(message);
        } finally {
          this.loading = false;
          if (refresh) {
            this.refreshing = false;
          }
        }
      }
    },
    async refreshTickets() {
      if (this.loading) {
        return;
      }
      this.$store.dispatch('setGlobalValue', {
        item: this.cache,
        key: 'tickets',
        value: false,
      });
      this.loadTickets('refresh');
    },
    setSortKey(k) {
      this.sortKey = k;
      this.sortMap[k] = this.sortMap[k] * -1;
    },
    cleanItem(item, col) {
      let i = item || '--';
      if (['created', 'updated'].includes(col) && i !== '--') {
        i = this.formatTime(i);
      }
      if (['priority', 'status'].includes(col)) {
        i = this._startCase(i);
      }
      return i;
    },
    highlight(ctx, query, col) {
      const c = this.cleanItem(ctx, col);
      return c.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    formatTime(time) {
      return this._zoneFormat({ date: time, format: 'MMM DD, YYYY h:mm a' });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/support/tickets/ticket-list/index.js